module.exports = __webpack_public_path__ + "img/logoHome.2cd25c94.svg";